import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row q-col-gutter-x-lg" }
const _hoisted_2 = { class: "row q-col-gutter-x-lg" }
const _hoisted_3 = { class: "col self-center" }

import { finalize } from 'rxjs/operators';
import axios, { AxiosError } from 'axios';
import {
  computed, reactive, ref, toRefs, withDefaults,
} from 'vue';
import Cookies from 'quasar/src/plugins/Cookies.js';import Notify from 'quasar/src/plugins/Notify.js';import useQuasar from 'quasar/src/composables/use-quasar.js';;
import User from '@/models/User';
import Me from '@/modules/auth/data/MeInterface';
import useBaseValidation from '@/hooks/validation/useBaseValidation';
import authApiService from '@/api/authApiService';
import userApiService from '@/api/userApiService';
import ChangePasswordDialog from '@/dialogs/ChangePasswordDialog/ChangePasswordDialog.vue';
import { DialogEventType } from '@/common/Dialog';
import Dialog from '@/common/Dialog/Dialog.vue';
import useNumberPhone from '@/hooks/useNumberPhone';
import InputPhone from '@/components/InputPhone/InputPhone.vue';
import { LOGOUT } from '@/graphql/auth';
import qs from 'qs';
import { print } from 'graphql/language';
import Lang from '@/components/Lang/Lang.vue';

type Props = {
    user?: Me
}


export default /*#__PURE__*/_defineComponent({
  __name: 'UserProfileDialog',
  props: {
    user: { default: {
    name: null,
    username: null,
    email: null,
    password: null,
    phone: null,
    countryCode: '+7',
    organizationId: null,
    provider: null,
    roles: [],
  } }
  },
  setup(__props: any) {

const props = __props;


const q = useQuasar();
const { required } = useBaseValidation();



const { user } = toRefs(props);
const { getValidPhone } = useNumberPhone();

const currentUser = reactive<Me>({
  ...(user.value as Me),
});

const form = ref(null);

const loading = ref(false);

const serverError = ref<{ [key: string]: string[] }>({});

const isUpdate = computed(() => !!currentUser && !!currentUser.id);

const changePassword = () => {
  q.dialog({
    component: ChangePasswordDialog,
    componentProps: { user: currentUser },
  });
};

const success = (data: User, onDialogOK: (payload?: User) => void) => {
  authApiService.getUser()
    .pipe(
      finalize(() => onDialogOK(data)),
    )
    .subscribe();
};

const errorHandler = (e: AxiosError<{ errors: { [key: string]: string[] } }>) => {
  if (e.request.status === 422) {
    serverError.value = e.response.data.errors;
  } else {
    throw e;
  }
};

const saveData$ = () => {
  if (isUpdate.value) {
    const {
      username, phone, email, name, id, countryCode,
    } = currentUser;
    return userApiService.edit(id, {
      name, email, phone: getValidPhone(phone), username, countryCode,
    });
  }
  return userApiService.add(currentUser);
};

const handlerSave = async ({ onDialogOK }: DialogEventType<User>) => {
  if (await form.value.validate(true)) {
    loading.value = true;
    saveData$().pipe(finalize(() => {
      loading.value = false;
    }))
      .subscribe(
        (data) => {
          success(data, onDialogOK);
        },
        errorHandler,
      );
  }
};

const logoutApollo = () => axios.create({
  baseURL: `${process.env.VUE_APP_API_URL}/public`,
  headers: {
    'Content-Type': 'application/json',
  },
  paramsSerializer(params) {
    return qs.stringify(params, { arrayFormat: 'brackets' });
  },
})
  .post('/', {
    query: print(LOGOUT),
  })
  .then(() => {
    Cookies.remove('_token-gql');
  })
  .catch((e) => {
    Notify.create({
      type: 'negative',
      message: e.message,
    });
  });

const logout = ({ onDialogCancel }: DialogEventType<User>) => {
  logoutApollo();
  authApiService.logout();
  onDialogCancel();
};

return (_ctx: any,_cache: any) => {
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_form = _resolveComponent("q-form")!

  return (_openBlock(), _createBlock(Dialog, {
    "loading-save-data": loading.value,
    "hide-destroy-button": false,
    title: _ctx.$t('personalAccount.title'),
    width: "narrow",
    "icon-destroy-button": "mdi-logout",
    "destroy-label-btn": _ctx.$t('comeOut'),
    "title-dialog-confirm": _ctx.$t('warning'),
    "message-dialog-confirm": _ctx.$t('personalAccount.wantQuit'),
    onOnDestroy: logout,
    onOnCancel: _cache[11] || (_cache[11] = ({ onDialogCancel }) => onDialogCancel()),
    onOnOk: handlerSave
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_form, {
        ref_key: "form",
        ref: form
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_input, {
            modelValue: currentUser.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentUser.name) = $event)),
            label: _ctx.$t('personalAccount.fullName'),
            rules: [_unref(required)],
            error: serverError.value.name && !!serverError.value.name.length,
            "error-message": serverError.value.name && serverError.value.name[0],
            dense: "",
            autofocus: "",
            onKeydown: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.$refs.username.$el.focus()), ["enter"]))
          }, null, 8, ["modelValue", "label", "rules", "error", "error-message"]),
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_q_input, {
              ref: "username",
              modelValue: currentUser.username,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((currentUser.username) = $event)),
              class: "col-sm-6 col-xs-12",
              label: _ctx.$t('registry.login'),
              rules: [_unref(required)],
              error: serverError.value.username && !!serverError.value.username,
              "error-message": serverError.value.username && serverError.value.username[0],
              dense: "",
              onKeydown: [
                _cache[3] || (_cache[3] = ($event: any) => (serverError.value.username = null)),
                _cache[4] || (_cache[4] = _withKeys(($event: any) => (_ctx.$refs.phone.$el.focus()), ["enter"]))
              ]
            }, null, 8, ["modelValue", "label", "rules", "error", "error-message"]),
            _createVNode(InputPhone, {
              phone: currentUser.phone,
              "onUpdate:phone": _cache[5] || (_cache[5] = ($event: any) => ((currentUser.phone) = $event)),
              code: currentUser.countryCode,
              "onUpdate:code": _cache[6] || (_cache[6] = ($event: any) => ((currentUser.countryCode) = $event)),
              class: "col-sm-6 col-xs-12",
              "server-error": serverError.value.phone,
              error: serverError.value.phone && !!serverError.value.phone.length,
              "error-message": serverError.value.phone && serverError.value.phone[0],
              dense: "",
              onKeydown: [
                _cache[7] || (_cache[7] = ($event: any) => (serverError.value.phone = null)),
                _cache[8] || (_cache[8] = _withKeys(($event: any) => (_ctx.$refs.email.$el.focus()), ["enter"]))
              ]
            }, null, 8, ["phone", "code", "server-error", "error", "error-message"])
          ]),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_q_input, {
              ref: "email",
              modelValue: currentUser.email,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((currentUser.email) = $event)),
              label: _ctx.$t('registry.email'),
              class: "col-sm-6 col-xs-12",
              rules: [_unref(required)],
              error: serverError.value.email && !!serverError.value.email.length,
              "error-message": serverError.value.email && serverError.value.email[0],
              dense: "",
              onKeydown: _cache[10] || (_cache[10] = ($event: any) => (serverError.value.email = null))
            }, null, 8, ["modelValue", "label", "rules", "error", "error-message"]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_q_btn, {
                class: "ma-1 deleteBtn",
                color: "primary",
                onClick: changePassword
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('personalAccount.changePassword')), 1)
                ]),
                _: 1
              })
            ])
          ]),
          _createVNode(Lang)
        ]),
        _: 1
      }, 512)
    ]),
    _: 1
  }, 8, ["loading-save-data", "title", "destroy-label-btn", "title-dialog-confirm", "message-dialog-confirm"]))
}
}

})